<fly-modal
  #modal
  [header]="'CANCEL SUBSCRIPTION?'"
  [buttons]="[
    {
      text: 'Close',
      action: 'close'
    },
    {
      text: 'Cancel Subscription',
      primary: true,
      action: modalConfirm
    }
  ]">
  <div slot="body">
    <div class="content">
      @if (cancelAction() === CancelMode.CANCEL_PROMOTION) {
        <p> By cancelling this subscription, you will lose access to premium features once your trial ends. </p>
      } @else {
        <p>
          By cancelling this subscription, auto-renew will be turned off and your subscription will expire on the date
          noted.
        </p>
      }
    </div>
  </div>
</fly-modal>
